{
  "actions": "اعمال",
  "activeStakes": "فعال اسٹیکس",
  "apy": "اے پی وائی",
  "claimNow": "ابھی کلیم کریں",
  "claimRewards": "ریوارڈ حاصل کریں",
  "claimRewardsFailed": "ریوارڈ حاصل نہیں ہوسکا۔",
  "days": "دن",
  "duration": "دورانیہ",
  "enterExaltAmount": "EXALT کی مقدار درج کریں",
  "enterStakeAmount": "اسٹیک کرنے کے لیے رقم درج کریں",
  "enterValidExaltAmount": "براہ کرم EXALT کی درست مقدار درج کریں۔",
  "enterValidStakeAmount": "براہ کرم درست اسٹیک رقم درج کریں۔",
  "estimatedApr": "متوقع APR",
  "estimatedRewards": "متوقع ری وارڈز",
  "exaltStaking": "EXALT اسٹیکنگ",
  "insufficientBalance": "ناکافی EXALT بیلنس۔",
  "loading": "لوڈ ہو رہا ہے...",
  "lockPeriod": "لاک مدت",
  "minimumStake": "کم از کم اسٹیک",
  "nextReward": "اگلا ری وارڈ",
  "noActiveStakesYet": "ابھی کوئی فعال اسٹیک موجود نہیں",
  "noRewardHistory": "کوئی ری وارڈ تاریخ دستیاب نہیں۔",
  "pendingReward": "زیر التواء ریوارڈ",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "rewardHistory": "ری وارڈ تاریخ",
  "rewardRate": "ری وارڈ شرح",
  "rewardsClaimedSuccessfully": "ریوارڈ کامیابی سے حاصل ہوگیا۔",
  "rewardsEarned": "حاصل شدہ انعامات",
  "securityNotice": "سیکیورٹی نوٹس",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "stake": "اسٹیک",
  "stakeCompleted": "مکمل",
  "stakeExalt": "EXALT اسٹیک کریں",
  "stakeHistory": "اسٹیک تاریخ",
  "stakeNow": "ابھی اسٹیک کریں",
  "stakingFailed": "اسٹیکنگ ناکام ہوگئی۔",
  "stakingSecurity1": "ری وارڈز بیک اینڈ تصدیق کے بعد جمع کیے جاتے ہیں۔",
  "stakingSecurity2": "جلد اَن اسٹیک کرنے کے قواعد لاگو ہو سکتے ہیں۔",
  "stakingSecurity3": "غیر معمولی صورتوں میں اونر/ایڈمن کی منظوری درکار ہو سکتی ہے۔",
  "stakingSecurity4": "پروسیسنگ سے پہلے بلاک چین تصدیقات کی توثیق کی جاتی ہے۔",
  "stakingStartedSuccessfully": "اسٹیکنگ کامیابی سے شروع ہوگئی۔",
  "stakingSubtitle": "EXALT اسٹیک کریں اور مستقل ریوارڈ حاصل کریں",
  "stakingTitle": "ایگزالٹ اسٹیکنگ",
  "totalRewards": "کل انعامات",
  "totalStaked": "کل اسٹیک شدہ",
  "unavailable": "دستیاب نہیں",
  "unstake": "اَن اسٹیک کریں",
  "unstakeFailed": "اَن اسٹیک ناکام ہوگیا۔",
  "unstakeNow": "ابھی ان اسٹیک کریں",
  "unstakedSuccessfully": "اَن اسٹیک کامیابی سے ہوگیا۔"
}